import React from 'react';
import ExchangeForm from '../../../components/client/ExchangeForm/ExchangeForm';

const ExchangePage = () => {
    return <ExchangeForm />;
};

export default ExchangePage;
